const state = {
    employmentStatuses: [],
    residentialStatuses: [],
    sellerTypes: [],
    loanTypes: [],
    assetTypes: [],
    documentTypes: [],
    referrers: [],
    brokers: [],
    sources: [],
    sourceDetails: [],
    closeReasons: [],
    preferredRepaymentFrequency: [],
    preferredRepaymentTerm: [],
    applicationTypes: [],
    paymentTypes: [],
    applicationJoins: [],
    leadTypes: [],
    employmentIndustries: [],
    occupations: [],
    lenders: [],
    applicationCategories: [],
    enableLatitudeSubmitToLender: false,
    enableWisrSubmitToLender: false,
    enableGlaSubmitToLender: false,
    enableMacquarieSubmitToLender: false,
    enableFirstmacSubmitToLender: false,
    enableNowFinanceSubmitToLender: false,
    enableMetroSubmitToLender: false,
    enableAffordableCarLoansSubmitToLender: false,
    enableMasterWisrSubmitToLender: false,
    enableMasterGlaSubmitToLender: false,
    enableMasterMacquarieSubmitToLender: false,
    enableMasterFirstmacSubmitToLender: false,
    enableMasterNowFinanceSubmitToLender: false,
    enableMasterMetroSubmitToLender: false,
    enableMasterAffordableCarLoansSubmitToLender: false,
}

const getters = {
    employmentStatuses: (state) => {
        return state.employmentStatuses
    },
    residentialStatuses: (state) => {
        return state.residentialStatuses
    },
    sellerTypes: (state) => {
        return state.sellerTypes
    },
    loanTypes: (state) => {
        return state.loanTypes
    },
    assetTypes: (state) => {
        return state.assetTypes
    },
    documentTypes: (state) => {
        return state.documentTypes
    },
    referrers: (state) => {
        return state.referrers
    },
    brokers: (state) => {
        return state.brokers
    },
    sources: (state) => {
        return state.sources
    },
    sourceDetails: (state) => {
        return state.sourceDetails
    },
    closeReasons: (state) => {
        return state.closeReasons
    },
    preferredRepaymentFrequency: (state) => {
        return state.preferredRepaymentFrequency
    },
    preferredRepaymentTerm: (state) => {
        return state.preferredRepaymentTerm
    },
    applicationTypes: (state) => {
        return state.applicationTypes
    },
    paymentTypes: (state) => {
        return state.paymentTypes
    },
    applicationJoins: (state) => {
        return state.applicationJoins
    },
    leadTypes: (state) => {
        return state.leadTypes
    },
    employmentIndustries: (state) => {
        return state.employmentIndustries
    },
    occupations: (state) => {
        return state.occupations
    },
    lenders: (state) => {
        return state.lenders
    },
    applicationCategories: (state) => {
        return state.applicationCategories
    },
    enableLatitudeSubmitToLender: (state) => {
        return state.enableLatitudeSubmitToLender
    },
    enableWisrSubmitToLender: (state) => {
        return state.enableWisrSubmitToLender
    },
    enableGlaSubmitToLender: (state) => {
        return state.enableGlaSubmitToLender
    },
    enableMacquarieSubmitToLender: (state) => {
        return state.enableMacquarieSubmitToLender
    },
    enableFirstmacSubmitToLender: (state) => {
        return state.enableFirstmacSubmitToLender
    },
    enableNowFinanceSubmitToLender: (state) => {
        return state.enableNowFinanceSubmitToLender
    },
    enableMetroSubmitToLender: (state) => {
        return state.enableMetroSubmitToLender
    },
    enableAffordableCarLoansSubmitToLender: (state) => {
        return state.enableAffordableCarLoansSubmitToLender
    },
    enableMasterWisrSubmitToLender: (state) => {
        return state.enableMasterWisrSubmitToLender
    },
    enableMasterGlaSubmitToLender: (state) => {
        return state.enableMasterGlaSubmitToLender
    },
    enableMasterMacquarieSubmitToLender: (state) => {
        return state.enableMasterMacquarieSubmitToLender
    },
    enableMasterFirstmacSubmitToLender: (state) => {
        return state.enableMasterFirstmacSubmitToLender
    },
    enableMasterNowFinanceSubmitToLender: (state) => {
        return state.enableMasterNowFinanceSubmitToLender
    },
    enableMasterMetroSubmitToLender: (state) => {
        return state.enableMasterMetroSubmitToLender
    },
    enableMasterAffordableCarLoansSubmitToLender: (state) => {
        return state.enableMasterAffordableCarLoansSubmitToLender
    },
}

const mutations = {
    saveEmploymentStatuses(state, statuses) {
        state.employmentStatuses = statuses
    },
    saveResidentialStatuses(state, statuses) {
        state.residentialStatuses = statuses
    },
    saveSellerTypes(state, types) {
        state.sellerTypes = types
    },
    saveLoanTypes(state, types) {
        state.loanTypes = types
    },
    saveAssetTypes(state, types) {
        state.assetTypes = types
    },
    saveDocumentTypes(state, types) {
        state.documentTypes = types
    },
    saveReferrers(state, referrers) {
        state.referrers = referrers
    },
    saveBrokers(state, brokers) {
        state.brokers = brokers
    },
    saveSources(state, sources) {
        state.sources = sources
    },
    saveSourceDetails(state, sourceDetails) {
        state.sourceDetails = sourceDetails
    },
    saveCloseReasons(state, reasons) {
        state.closeReasons = reasons
    },
    savePreferredRepaymentFrequency(state, frequency) {
        state.preferredRepaymentFrequency = frequency
    },
    savePreferredRepaymentTerm(state, term) {
        state.preferredRepaymentTerm = term
    },
    saveApplicationTypes(state, types) {
        state.applicationTypes = types
    },
    savePaymentTypes(state, types) {
        state.paymentTypes = types
    },
    saveApplicationJoins(state, types) {
        state.applicationJoins = types
    },
    saveLeadTypes(state, types) {
        state.leadTypes = types
    },
    saveEmploymentIndustries(state, industries) {
        state.employmentIndustries = industries
    },
    saveOccupations(state, occupations) {
        state.occupations = occupations
    },
    saveLenders(state, lenders) {
        state.lenders = lenders
    },
    saveApplicationCategories(state, applicationCategories) {
        state.applicationCategories = applicationCategories
    },
    saveEnableLatitudeSubmitToLender(state, enableLatitudeSubmitToLender) {
        state.enableLatitudeSubmitToLender = enableLatitudeSubmitToLender
    },
    saveEnableWisrSubmitToLender(state, enableWisrSubmitToLender) {
        state.enableWisrSubmitToLender = enableWisrSubmitToLender
    },
    saveEnableGlaSubmitToLender(state, enableGlaSubmitToLender) {
        state.enableGlaSubmitToLender = enableGlaSubmitToLender
    },
    saveEnableMacquarieSubmitToLender(state, enableMacquarieSubmitToLender) {
        state.enableMacquarieSubmitToLender = enableMacquarieSubmitToLender
    },
    saveEnableFirstmacSubmitToLender(state, enableFirstmacSubmitToLender) {
        state.enableFirstmacSubmitToLender = enableFirstmacSubmitToLender
    },
    saveEnableNowFinanceSubmitToLender(state, enableNowFinanceSubmitToLender) {
        state.enableNowFinanceSubmitToLender = enableNowFinanceSubmitToLender
    },
    saveEnableMetroSubmitToLender(state, enableMetroSubmitToLender) {
        state.enableMetroSubmitToLender = enableMetroSubmitToLender
    },
    saveEnableAffordableCarLoansSubmitToLender(state, enableAffordableCarLoansSubmitToLender) {
        state.enableAffordableCarLoansSubmitToLender = enableAffordableCarLoansSubmitToLender
    },
    saveMasterEnableWisrSubmitToLender(state, enableMasterWisrSubmitToLender) {
        state.enableMasterWisrSubmitToLender = enableMasterWisrSubmitToLender
    },
    saveMasterEnableGlaSubmitToLender(state, enableMasterGlaSubmitToLender) {
        state.enableMasterGlaSubmitToLender = enableMasterGlaSubmitToLender
    },
    saveMasterEnableMacquarieSubmitToLender(state, enableMasterMacquarieSubmitToLender) {
        state.enableMasterMacquarieSubmitToLender = enableMasterMacquarieSubmitToLender
    },
    saveMasterEnableFirstmacSubmitToLender(state, enableMasterFirstmacSubmitToLender) {
        state.enableMasterFirstmacSubmitToLender = enableMasterFirstmacSubmitToLender
    },
    saveMasterEnableNowFinanceSubmitToLender(state, enableMasterNowFinanceSubmitToLender) {
        state.enableMasterNowFinanceSubmitToLender = enableMasterNowFinanceSubmitToLender
    },
    saveMasterEnableMetroSubmitToLender(state, enableMasterMetroSubmitToLender) {
        state.enableMasterMetroSubmitToLender = enableMasterMetroSubmitToLender
    },
    saveMasterEnableAffordableCarLoansSubmitToLender(state, enableMasterAffordableCarLoansSubmitToLender) {
        state.enableMasterAffordableCarLoansSubmitToLender = enableMasterAffordableCarLoansSubmitToLender
    },
}

const actions = {
    saveEmploymentStatuses(context, statuses) {
        context.commit("saveEmploymentStatuses", statuses)
    },
    saveResidentialStatuses(context, statuses) {
        context.commit("saveResidentialStatuses", statuses)
    },
    saveSellerTypes(context, types) {
        context.commit("saveSellerTypes", types)
    },
    saveLoanTypes(context, types) {
        context.commit("saveLoanTypes", types)
    },
    saveAssetTypes(context, types) {
        context.commit("saveAssetTypes", types)
    },
    saveDocumentTypes(context, types) {
        context.commit("saveDocumentTypes", types)
    },
    saveReferrers(context, referrers) {
        context.commit("saveReferrers", referrers)
    },
    saveBrokers(context, brokers) {
        context.commit("saveBrokers", brokers)
    },
    saveSources(context, sources) {
        context.commit("saveSources", sources)
    },
    saveSourceDetails(context, sourceDetails) {
        context.commit("saveSourceDetails", sourceDetails)
    },
    saveCloseReasons(context, reasons) {
        context.commit("saveCloseReasons", reasons)
    },
    savePreferredRepaymentFrequency(context, frequency) {
        context.commit("savePreferredRepaymentFrequency", frequency)
    },
    savePreferredRepaymentTerm(context, term) {
        context.commit("savePreferredRepaymentTerm", term)
    },
    saveApplicationTypes(context, types) {
        context.commit("saveApplicationTypes", types)
    },
    savePaymentTypes(context, types) {
        context.commit("savePaymentTypes", types)
    },
    saveApplicationJoins(context, types) {
        context.commit("saveApplicationJoins", types)
    },
    saveLeadTypes(context, types) {
        context.commit("saveLeadTypes", types)
    },
    saveEmploymentIndustries(context, industries) {
        context.commit("saveEmploymentIndustries", industries)
    },
    saveOccupations(context, occupations) {
        context.commit("saveOccupations", occupations)
    },
    saveLenders(context, lenders) {
        context.commit("saveLenders", lenders)
    },
    saveApplicationCategories(context, applicationCategories) {
        context.commit("saveApplicationCategories", applicationCategories)
    },
    saveEnableLatitudeSubmitToLender(context, enableLatitudeSubmitToLender) {
        context.commit("saveEnableLatitudeSubmitToLender", enableLatitudeSubmitToLender)
    },
    saveEnableWisrSubmitToLender(context, enableWisrSubmitToLender) {
        context.commit("saveEnableWisrSubmitToLender", enableWisrSubmitToLender)
    },
    saveEnableGlaSubmitToLender(context, enableGlaSubmitToLender) {
        context.commit("saveEnableGlaSubmitToLender", enableGlaSubmitToLender)
    },
    saveEnableMacquarieSubmitToLender(context, enableMacquarieSubmitToLender) {
        context.commit("saveEnableMacquarieSubmitToLender", enableMacquarieSubmitToLender)
    },
    saveEnableFirstmacSubmitToLender(context, enableFirstmacSubmitToLender) {
        context.commit("saveEnableFirstmacSubmitToLender", enableFirstmacSubmitToLender)
    },
    saveEnableNowFinanceSubmitToLender(context, enableNowFinanceSubmitToLender) {
        context.commit("saveEnableNowFinanceSubmitToLender", enableNowFinanceSubmitToLender)
    },
    saveEnableMetroSubmitToLender(context, enableMetroSubmitToLender) {
        context.commit("saveEnableMetroSubmitToLender", enableMetroSubmitToLender)
    },
    saveEnableAffordableCarLoansSubmitToLender(context, enableAffordableCarLoansSubmitToLender) {
        context.commit("saveEnableAffordableCarLoansSubmitToLender", enableAffordableCarLoansSubmitToLender)
    },
    saveMasterEnableWisrSubmitToLender(context, enableMasterWisrSubmitToLender) {
        context.commit("saveMasterEnableWisrSubmitToLender", enableMasterWisrSubmitToLender)
    },
    saveMasterEnableGlaSubmitToLender(context, enableMasterGlaSubmitToLender) {
        context.commit("saveMasterEnableGlaSubmitToLender", enableMasterGlaSubmitToLender)
    },
    saveMasterEnableMacquarieSubmitToLender(context, enableMasterMacquarieSubmitToLender) {
        context.commit("saveMasterEnableMacquarieSubmitToLender", enableMasterMacquarieSubmitToLender)
    },
    saveMasterEnableFirstmacSubmitToLender(context, enableMasterFirstmacSubmitToLender) {
        context.commit("saveMasterEnableFirstmacSubmitToLender", enableMasterFirstmacSubmitToLender)
    },
    saveMasterEnableNowFinanceSubmitToLender(context, enableMasterNowFinanceSubmitToLender) {
        context.commit("saveMasterEnableNowFinanceSubmitToLender", enableMasterNowFinanceSubmitToLender)
    },
    saveMasterEnableMetroSubmitToLender(context, enableMasterMetroSubmitToLender) {
        context.commit("saveMasterEnableMetroSubmitToLender", enableMasterMetroSubmitToLender)
    },
    saveMasterEnableAffordableCarLoansSubmitToLender(context, enableMasterAffordableCarLoansSubmitToLender) {
        context.commit("saveMasterEnableAffordableCarLoansSubmitToLender", enableMasterAffordableCarLoansSubmitToLender)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
